import { Component, Input, OnInit } from '@angular/core';
import { ValueMetricsProductType } from '../../../../constants-types';
import { ValueMetricLimit } from '../../../../core-data-model';
import { TranslationService } from '../../../../translations';

@Component({
    selector: 'subscription-activations',
    template: `
        <div class="title">
            {{ TR.key('subscription-manager.overview-activations') }}
        </div>
        @if (!!valueMetrics && valueMetrics.length > 0) {
            <dl class="inlineDL">
                <dd>
                    <div class="activation-flex activation-title">
                        <div>
                            {{
                                this.TR.key(
                                    'subscription-manager.overview-activations-product'
                                )
                            }}
                        </div>
                        <div>
                            {{
                                this.TR.key(
                                    'subscription-manager.overview-activations-subscription-total'
                                )
                            }}
                        </div>
                        <div>
                            {{
                                this.TR.key(
                                    'subscription-manager.overview-activations-consumed'
                                )
                            }}
                        </div>
                        <div>
                            {{
                                this.TR.key(
                                    'subscription-manager.overview-activations-available'
                                )
                            }}
                        </div>
                    </div>
                    @for (vm of valueMetrics; track vm) {
                        <div class="activation-flex">
                            <div class="vm-display-name">
                                {{ getProductName(vm.product) }}
                            </div>
                            <div class="vm-number">
                                {{ vm.limit | vmValue }}
                            </div>
                            <div>
                                <span class="vm-number">
                                    {{ vm.consumed }}
                                </span>
                                <span class="vm-action">
                                    {{
                                        this.TR.key(
                                            vm.displayNameTranslationKey
                                        ) + ' Activations'
                                    }}
                                </span>
                            </div>
                            <div class="vm-number">
                                {{ vm.available | vmValue }}
                            </div>
                        </div>
                    }
                </dd>
            </dl>
        }
    `,
    styleUrls: ['./activations.component.less', '../overview.component.less'],
    standalone: false
})
export class AccountSubscriptionActivationsComponent implements OnInit {
    @Input()
    valueMetrics: ValueMetricLimit[] = [];

    constructor(public TR: TranslationService) {}

    async ngOnInit() {
        this.valueMetrics = this.valueMetrics.filter(
            (x) => x.displayNameTranslationKey.length > 0
        );
    }

    getProductName(product: ValueMetricsProductType): string {
        switch (product) {
            case ValueMetricsProductType.HireHero: {
                return 'Hire';
            }
            case ValueMetricsProductType.Design2: {
                return 'Design';
            }
            default: {
                return '';
            }
        }
    }
}
